"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var BannerInfo = /*#__PURE__*/(0, _react.forwardRef)(function (props) {
  var styleType = props.styleType,
    style = props.style,
    _a = props.infoList,
    infoList = _a === void 0 ? [] : _a,
    _b = props.privilegeList,
    privilegeList = _b === void 0 ? [] : _b,
    labelName = props.labelName,
    flexTitle = props.flexTitle;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-banner-info', {
      'light-house-style': styleType === 'lightHouse'
    }),
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-banner-info-container"
  }, flexTitle && ( /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-banner-info-container_title"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-banner-info-container_title__span"
  }, flexTitle))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-banner-info-children"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-banner-info-children_left"
  }, infoList.map(function (item, index) {
    var _a = item || {},
      title = _a.title,
      description = _a.description,
      icon = _a.icon;
    var _b = (0, _utils.fomateFileData)(icon),
      url = _b.url,
      _c = _b.alt,
      alt = _c === void 0 ? '' : _c;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: "flex-banner-info-children_left__children"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-banner-info-children_left__children__container'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'list_img_container'
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: 'list__img',
      src: url,
      alt: alt
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'list__head'
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      className: 'list__title'
    }, title), /*#__PURE__*/_react["default"].createElement("p", {
      className: 'list__description'
    }, description))));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-banner-info-children_right"
  }, labelName && /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-banner-info-children_right_span"
  }, labelName), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-banner-info-children_right_bg"
  }), privilegeList.map(function (item, index) {
    var _a = item || {},
      title = _a.title,
      description = _a.description;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: "flex-banner-info-children_right__children"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-banner-info-children_left__children__container'
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: 'list__index'
    }, index + 1), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'list__head'
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      className: 'list__title'
    }, title), /*#__PURE__*/_react["default"].createElement("p", {
      className: 'list__description'
    }, description))));
  })))));
});
BannerInfo.displayName = 'TCIBannerInfo';
var _default = exports["default"] = BannerInfo;